import { AgentToolCallStatus, } from '@debbie/common/dist/agents/index.js';
import { proposalTitle } from '@debbie/cortex/dist/agents/index.js';
import moment from 'moment';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import THEME from '../../theme.js';
import ProposalCard, { ProposalStatusBadge, } from '../AgentProposals/ProposalCard.js';
import AI from '../AI.js';
import Panel from '../Panel.js';
import PerformedBy from '../performed-by/PerformedBy.js';
import HistItem from './HistItem.js';
const AgentProposalItem = ({ date, data }) => {
    const lang = useSelector((s) => s.lang);
    const [expanded, setExpanded] = useState(false);
    const title = proposalTitle(data.toolName, data.appliedInput ?? data.proposedInput, lang);
    return (React.createElement(HistItem, { date: date },
        React.createElement(ProposalPanel, { noBodyPadding: true },
            React.createElement("details", { onToggle: (event) => setExpanded(event.currentTarget.open) },
                React.createElement(Summary, null,
                    React.createElement(AIIndicator, { "aria-hidden": "true" },
                        React.createElement(AI, { height: "14px" })),
                    React.createElement(SummaryTitle, { title: title },
                        data.appliedInput != null
                            ? lang.agentProposals.appliedInput
                            : lang.agentProposals.proposedInput,
                        ": ",
                        title),
                    React.createElement(ProposalStatusBadge, { status: data.status })),
                expanded && (React.createElement(DetailsBody, null,
                    React.createElement(ProposalCard, { proposal: data, caseId: data.caseId, previewEnabled: false, showValidationErrors: data.status === AgentToolCallStatus.Proposed, embedded: true }),
                    data.decidedAt && (React.createElement(DecisionDetails, null,
                        lang.agentProposals.decidedBy,
                        ":",
                        ' ',
                        data.decidedBy && (React.createElement(PerformedBy, { performedBy: data.decidedBy })),
                        ' · ',
                        moment(data.decidedAt).format(THEME.DATE_FORMAT_LONG))),
                    data.decisionReason && (React.createElement(DecisionDetails, null, data.decisionReason))))))));
};
export default AgentProposalItem;
const ProposalPanel = styled(Panel) `
  margin-top: 8px;
`;
const Summary = styled.summary `
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  padding: 10px;
  font-size: 0.8em;
  color: ${THEME.COLOR_PRIMARY};
  list-style: none;
  border-radius: 4px;

  &::-webkit-details-marker {
    display: none;
  }

  > span:last-child {
    margin-bottom: 0;
    flex-shrink: 0;
    font-size: inherit;
    font-weight: 500;
  }

  &:focus-visible {
    outline: 2px solid ${THEME.COLOR_ACCENT};
    outline-offset: -2px;
  }
`;
const SummaryTitle = styled.span `
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
const AIIndicator = styled.span `
  display: inline-flex;
  flex-shrink: 0;
  pointer-events: none;
`;
const DetailsBody = styled.div `
  padding: ${THEME.GRID_SPACING}px;
  border-top: 1px solid
    color-mix(in srgb, ${THEME.COLOR_PRIMARY} 8%, transparent);
`;
const DecisionDetails = styled.p `
  margin: 12px 0 0;
  font-size: 0.8em;
  color: ${THEME.COLOR_GREY};
`;
//# sourceMappingURL=AgentProposalItem.js.map